// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"328":"f49e4173","605":"d90f05a8"}[chunkId] + ".chunk.js";
};